import type { FormatterMap, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
} from '@grandvisionhq/www-next/formatters'

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),

  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('book-appointment-v3'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createMyAccountFormatters(),
  ...createAuthFormatters(),
  'order.confirm': createSimpleFormatter('order/confirm'),
  'express-checkout': createSimpleFormatter('express-checkout'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { login: 'login', shipping: 'shipping', overview: 'overview', payment: 'payment' },
  }),
  ...productDetailFormatters({
    accessories: 'eyecare-and-accessories',
    'contact-lenses': 'contact-lenses',
    frames: 'glasses',
    solutions: 'contact-lenses/solutions',
    sunglasses: 'sunglasses',
  }),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/shipping', 'checkout.shipping'],
  ['/checkout/overview', 'checkout.overview'],
  ['/checkout/payment', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/express-checkout', 'express-checkout'],

  ['/book-appointment/(.*)?', 'appointments.book'],
  ['/reschedule-appointment', 'appointments.reschedule'],
  ['/cancel-appointment', 'appointments.cancel'],
]
